import { cn } from '@risksmart-app/atomic-ui';
import { getColorStyles } from '@risksmart-app/components/src/utils/colours';
import type { ResolvedRating } from 'src/ratings/useRiskRatingResolver';

interface RatingBadgeProps {
  rating: ResolvedRating | undefined;
  notRatedLabel: string;
  /**
   * Tri-state control over the parenthetical value (always one decimal place):
   * - omitted (`undefined`) → render `rating.value` (L/I rows)
   * - a `number` → render this value instead (the overall risk score)
   * - `null` → render the label with no parenthetical
   */
  displayValue?: number | null;
  className?: string;
  testId?: string;
}

const RatingBadge = ({
  rating,
  notRatedLabel,
  displayValue,
  className,
  testId,
}: RatingBadgeProps) => {
  if (!rating) {
    return (
      <span
        className={cn(
          'inline-flex items-center rounded-sm whitespace-nowrap bg-neutral-muted text-neutral-muted-foreground',
          className
        )}
        data-testid={testId}
      >
        {notRatedLabel}
      </span>
    );
  }

  return (
    <span
      className={cn(
        'inline-flex items-center rounded-sm whitespace-nowrap',
        className
      )}
      style={getColorStyles(rating.color)}
      data-testid={testId}
    >
      {displayValue === null
        ? rating.label
        : `${rating.label} (${(displayValue ?? rating.value).toFixed(1)})`}
    </span>
  );
};

export { RatingBadge };
